export default "__VITE_ASSET__CKmAd$p___"